<script>
import {  common } from '@/mixins/common';
import { PostApiWithAuthorizationAction } from '../../../helpers/apiActions';

export default {
  name: 'CompleteOrderDialog',
  components: {},
  props: {
    displayDialog: {
      type: Boolean,
      required: true
    },
    systemSetting: {
      type: Object,
      required: true,
      default() {
        return {
          maxBarcodeCount: 5
        }
      }
    },
    data: {
      type: Object,
      required: true,
      default() {
        return {
          totalRemainingItems: 0,
          totalItemsScanned: 0,
          totalOrderRemaining: 0,
          orders: [],
          selectedOrder: {
            extendedOrderID: ""
          }
        }
      }
    }
  },
  data() {
    return {
      error: '',
      form: {
        barcode: ''
      },
      rules: {
        barcode: [
          { required: true, message: 'Barcode field is required.', trigger: 'change' },
          { min: 5, message: 'Barcode should have 5 characters length.', trigger: 'change' }
        ]
      },
      remainingOrders: []
    }
  },
  mixins: [
    common
  ],
  mounted() {
    // const _vm = this
  },
  methods: {
    scanBarcode() {
      let _vm = this
      // eslint-disable-next-line
      console.log(_vm.remainingOrders)
      _vm.$refs.formContainer.validate((valid) => {
        if (valid) {
          PostApiWithAuthorizationAction("admin/orders/complete-order", {
            barcode: _vm.form.barcode,
            orderId: _vm.selectedOrder.id
          })
          .then(res => {
            if (res.status == 'success') {
              if (res.data.totalRemainingItems == 0) {
                if (_vm.remainingOrders.length === 0) {//no orders left
                  _vm.$root.$emit('remove-order', _vm.selectedOrder.id)
                  _vm.$root.$emit('close-dialog', 'displayCompleteOrderDialog')
                } else {//move to next order
                  _vm.selectedOrder = _vm.remainingOrders[0]
                  _vm.remainingOrders = _vm.remainingOrders.slice(1)
                }
              }
              _vm.totalItemsScanned = res.data.totalItemsScanned
              _vm.totalRemainingItems = res.data.totalRemainingItems
              _vm.form.barcode = ''
              _vm.error = ''
            } else {
              _vm.error = res.message
            }
          });
        }
      });
    },
    handleDialogClose() {
      this.$root.$emit('close-dialog', 'displayCompleteOrderDialog')
    }
  },
  computed: {
    totalOrderRemaining() {
      return this.remainingOrders.length 
    }
  },
  watch: {
    'data.orders': function(newValue) {
      const _vm = this
      _vm.selectedOrder = newValue.length > 0 ? newValue[0] : { extendedOrderID: "" }
      this.remainingOrders = newValue.slice(1)
      this.form.barcode = ''
      this.totalItemsScanned = this.data.totalItemsScanned
      this.totalRemainingItems = this.data.totalRemainingItems
      setTimeout(() => {
        this.$refs.drawerPrimaryField.focus()
      }, 100)
    },
    'form.barcode': function() {
      this.error = ''
    },
  }
}
</script>

<template>
    <el-dialog
      custom-class="el-dialog-bs-info"
      :visible.sync="displayDialog"
      width="40%"
      @close="handleDialogClose">
      <span slot="title"><h5><i class="fas fa-qrcode"></i> COMPLETE ORDER : {{ selectedOrder.extendedOrderID }}</h5></span>
      <el-form
        :model="form"
        @submit.native.prevent="scanBarcode"
        ref="formContainer"
        id="identifierForm">
        <div class="mb-1 pt-1 text-center">
            <el-button type="primary" @click="viewList()">
                <i class="fas fa-list-alt"></i> ITEMS LIST
            </el-button>
        </div>
        <div class="my-2 mb-3">
          <el-form-item
            class="mb-1"
            :rules="rules.barcode"
            prop="barcode">
            <el-input
              ref="drawerPrimaryField"
              :maxlength="systemSetting.maxBarcodeCount"
              placeholder="Type/Scan Barcode..."
              v-model="form.barcode"
              class="input-with-select">
              <el-button
                slot="append"
                native-type="submit"
                type="success">
                <i class="fas fa-paper-plane" style="transform: rotate(50deg);"></i>
              </el-button>
            </el-input>
            <div class="el-form-item__error">{{ error }}</div>
          </el-form-item>
        </div>
        <div class="text-center">
            <div id="order-barcode-remaining-count-div">
                <span id="warning-item-remaining"></span>
                <span class="span-order-count-item">{{ totalRemainingItems }}</span> items remaining
            </div>
            <div id="order-barcode-scanned-count-div">
                <span class="span-order-count-item">{{  totalItemsScanned }}</span> items scanned
            </div>
            <div id="order-remaining-count-div" v-if="data.orders.length > 1">
                <span class="span-order-count-remaining">{{ totalOrderRemaining }}</span> orders remaining
            </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer text-right">
        <el-button
          @click="displayDialog = false"
          type="danger">PAUSE</el-button>
      </span>
    </el-dialog>
</template>